import { request } from '@/network/request'

export default {
  /**
   * 媒体选项
   * @param {MediaSearch} Search 
   */
  MediaOptions (Search) {
    return request({
      url: "/media/mediaoptions",
      method: 'post',
      data: Search
    })
  }
}
